import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';

interface ProfileTabProps {
	handleLogout: () => void;
}

const PATH_TO_INDEX: Record<string, number> = {
	'/common/profile': 0
};

// ==============================|| HEADER PROFILE - TAB PROFIL ||============================== //

const ProfileTab: FC<ProfileTabProps> = ({ handleLogout }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [selectedIndex, setSelectedIndex] = useState<number | undefined>(0);

	useEffect(() => {
		setSelectedIndex(PATH_TO_INDEX[location.pathname] ?? undefined);
	}, [location.pathname]);

	const handleListItemClick = (index: number, route: string): void => {
		setSelectedIndex(index);
		if (route) navigate(route);
	};

	return (
		<List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
			<ListItemButton
				selected={selectedIndex === 0}
				onClick={() => handleListItemClick(0, '/common/profile')}
			>
				<ListItemIcon>
					<UserOutlined />
				</ListItemIcon>
				<ListItemText primary="Profilul meu" />
			</ListItemButton>
			<ListItemButton selected={selectedIndex === 1} onClick={handleLogout}>
				<ListItemIcon>
					<LogoutOutlined />
				</ListItemIcon>
				<ListItemText primary="Deconectare" />
			</ListItemButton>
		</List>
	);
};

export default ProfileTab;
